import React from 'react'
import { Link } from 'react-router-dom';

function ArticleItem(props) {
    console.log(props);
  return (
    <div className='w-full flex flex-col items-center mb-6'>
        <h4 className='w-full cursor-pointer hover:text-green-600 underline text-left font-bold text-black py-1 text-sm mb-1'>
            <Link to={props?.link} target='__blank'>
                {props?.title}
            </Link>
        </h4>
        <p 
            dangerouslySetInnerHTML={{ __html: props?.description?.slice(0, 250)?.replace(/<img[^>]*>/g,"...")+"..." }}
            className='w-full text-left text-black text-sm mb-1'>
        </p>
        <p className='w-full text-gray-700 text-left py-1 text-xs'>
            {new Date(props?.pubDate)?.toDateString('en-Us')}
        </p>
    </div>
  )
}

export default ArticleItem